import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

/**
 * UUID v4 that works outside secure contexts.
 *
 * `crypto.randomUUID()` is only exposed in secure contexts (HTTPS / localhost),
 * so it is `undefined` when the dev server is reached over a plain-HTTP LAN or
 * Tailscale IP — calling it there throws "crypto.randomUUID is not a function".
 * Prefer the native API where present, fall back to `getRandomValues` (which is
 * available in insecure contexts too), and finally to Math.random.
 */
export function randomUUID(): string {
  if (typeof crypto !== 'undefined') {
    if (typeof crypto.randomUUID === 'function') return crypto.randomUUID()
    if (typeof crypto.getRandomValues === 'function') {
      const b = crypto.getRandomValues(new Uint8Array(16))
      b[6] = (b[6] & 0x0f) | 0x40
      b[8] = (b[8] & 0x3f) | 0x80
      const h = Array.from(b, (x) => x.toString(16).padStart(2, '0'))
      return `${h[0]}${h[1]}${h[2]}${h[3]}-${h[4]}${h[5]}-${h[6]}${h[7]}-${h[8]}${h[9]}-${h[10]}${h[11]}${h[12]}${h[13]}${h[14]}${h[15]}`
    }
  }
  return generateUUID()
}

export function sanitizeText(text: string) {
  return text.replace('<has_function_call>', '')
}
export * from './format-util'
